import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch } from '@src/core/hooks';

import { setupLocale } from '@src/stores/userPreferences';
import { setupAuth } from '@src/features/customers';
import { loadAppInfo, setPublicKey } from '@src/stores/app';

import Footer from '@src/components/DirectLink/Footer';

import { getSessionId } from '@src/common';
import { setGlobalParameter } from '@src/stores/globalParameters';
import { Container } from '../Base/styles';
import DirectLink from '@src/widgets/DirectLink';

type RouteParams = {
  linkCode: string;
  apiKey: string;
};

export const NewLink = () => {
  const { apiKey, linkCode } = useParams<RouteParams>();

  const dispatch = useAppDispatch();

  const getDocumentLanguage = () => {
    const language = document.documentElement.lang;

    return language && language !== '' ? language : 'pt-br';
  };

  const initializeStore = (key: string, language: string) => {
    dispatch(setGlobalParameter('sessionId', getSessionId()));

    dispatch(setGlobalParameter('planne-link-code', linkCode));
    dispatch(setGlobalParameter('customer-access-token', ''));
    dispatch(setGlobalParameter('on-finish-checkout', ''));
    dispatch(setGlobalParameter('use-default-font', 'true'));

    dispatch(setupLocale(language));
    dispatch(setPublicKey(key));
    dispatch(setupAuth());
    // just a delay to avoid too much parallel requests
    setTimeout(() => {
      dispatch(loadAppInfo());
    }, 200);
  };

  useEffect(() => {
    if (linkCode) {
      const language = getDocumentLanguage();

      initializeStore(apiKey || '', language);
    }
  }, []);

  return (
    <>
      <Container>
        <DirectLink
          planneLinkCode={linkCode}
          customerAccessToken={undefined}
          onFinishCheckout={undefined}
          useDefaultFont={true}
        />
        <Footer />
      </Container>
    </>
  );
};

export default NewLink;
